import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserProvider } from './context/UserContext';
import { LoadingProvider, useLoading } from './context/LoadingContext';


import Mainpage from './pages/Mainpage/Mainpage';
import ScrollToTop from './ScrollToTop';
import Support from './pages/Support/Support';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import Article from './pages/Article/Article';
import Columns from './pages/Columns/Columns';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Copyright from './pages/Copyright/Copyright';
import Unsubscribe from './pages/Unsubscribe/Unsubscribe';
import Footer from './components/Footer/Footer';
import Search  from './pages/Search/Search';
import Adminpage from './pages/AdminPanel/Adminpage/Adminpage';
import Adminteam from './pages/AdminPanel/Adminteam/Adminteam';
import Login from './pages/AdminPanel/Adminlogin/Adminlogin';
import UploadArticle from './pages/AdminPanel/Adminupload/UploadArticle';
import Register from './pages/AdminPanel/Adminregister/Adminregister';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Adminusercontrol from './pages/AdminPanel/Adminusercontrol/Adminusercontrol';
import Adminpostcontrol from './pages/AdminPanel/Adminpostcontrol/Adminpostcontrol';
import Adminedit from './pages/AdminPanel/Adminedit/Adminedit';





function AppContent() {
  const [showSplash, setShowSplash] = React.useState(true);
  const location = useLocation();
  const { loading } = useLoading();
  const pathname = location.pathname;
  const isAdmin = pathname.startsWith('/admin');
  const isArticle = pathname.startsWith('/article');
  // Footer csak akkor jelenik meg, ha nem admin oldal van ÉS nem article loading overlay van
  return (
    <>
      <div className="bg_app"></div>
      <ScrollToTop />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Mainpage setShowSplash={setShowSplash} />} />
          <Route path="/about" element={<About />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/article/preview" element={<Article />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Support />} />
          <Route path="/columns" element={<Columns />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/copyright" element={<Copyright />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/search" element={<Search/>} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/register" element={<Register />} />
          <Route path="*" element={<Mainpage setShowSplash={setShowSplash} />} />
          <Route path="/admin/mainpage" element={<ProtectedRoute><Adminpage /></ProtectedRoute>} />
          <Route path="/admin/upload" element={<ProtectedRoute><UploadArticle /></ProtectedRoute>} />
          <Route path="/admin/usercontrol" element={<ProtectedRoute adminOnly={true}><Adminusercontrol /></ProtectedRoute>} />
          <Route path="/admin/postcontrol" element={<ProtectedRoute><Adminpostcontrol /></ProtectedRoute>} />
          <Route path="/admin/edit/:slug" element={<ProtectedRoute><Adminedit /></ProtectedRoute>} />
          <Route path="/admin/teamcontrol" element={<ProtectedRoute><Adminteam /></ProtectedRoute>} />
        </Routes>
      </div>
      {/* Footer csak akkor jelenik meg, ha nem admin oldal van ÉS nem article loading overlay van */}
      {(!isAdmin && !(isArticle && loading)) && <Footer />}
    </>
  );
}

function App() {
  return (
    <UserProvider>
      <LoadingProvider>
        <Router>
          <AppContent />
        </Router>
      </LoadingProvider>
    </UserProvider>
  );
}

export default App;
